"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TableCell_1 = require("./TableCell");
const MuiTableCellOverrides = {
    MuiTableCell: {
        styleOverrides: {
            head: ({ theme }) => ({
                color: theme.palette.gray[900],
                fontWeight: 600,
                lineHeight: 1.5,
                [`&.${TableCell_1.tableCellClasses.sizeMedium}:not(.${TableCell_1.tableCellClasses.paddingCheckbox}, .${TableCell_1.tableCellClasses.paddingNone})`]: {
                    padding: '17px 16px',
                },
            }),
            stickyHeader: ({ theme }) => ({
                color: theme.palette.gray[900],
                fontWeight: 600,
                lineHeight: 1.5,
                [`&.${TableCell_1.tableCellClasses.sizeMedium}:not(.${TableCell_1.tableCellClasses.paddingCheckbox}, .${TableCell_1.tableCellClasses.paddingNone})`]: {
                    padding: '17px 16px',
                },
            }),
            root: ({ theme }) => ({
                borderBottom: `1px solid ${theme.palette.gray[300]}`,
                [`&.${TableCell_1.tableCellClasses.sizeMedium}:not(.${TableCell_1.tableCellClasses.paddingCheckbox}, .${TableCell_1.tableCellClasses.paddingNone})`]: {
                    padding: '15px 16px',
                },
            }),
        },
    },
};
exports.default = MuiTableCellOverrides;
//# sourceMappingURL=MuiTableCellOverrides.js.map